import { VAppProviderType } from '@common/VerticalApps/types';
import { Fabric } from 'frontend/core/src/redux/types';
import { pickUniqueName } from 'frontend/core/src/utils';

export const getFabricNameUsingWorkspace = (workspaceName: string, provider: VAppProviderType, fabrics: Fabric[]) => {
  // replace spaces/special characters with underscores
  const sanitizedWorkspaceName = workspaceName.replace(/ /g, '_').replace(/[^a-zA-Z0-9_]/g, '_');

  const fabricName = `${provider}_${sanitizedWorkspaceName}`;
  return pickUniqueName(
    fabricName,
    fabrics.map((fabric) => fabric.name)
  );
};
